import React, { useState } from "react";
import Modal from "components/base/Modal";
import classNames from "classnames";
import Button from "components/Button";
import LoadingButton from "components/LoadingButton/LoadingButton";
import css from "../style.scss";

const ConfirmationModal = ({ 
    isOpen, 
    onClose, 
    title, 
    message, 
    confirmLabel = "Delete", 
    cancelLabel = "Cancel", 
    onConfirm, 
    isDanger = true
}) => {

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleConfirm = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            if (onConfirm) {
                await onConfirm();
            }
        } catch (err) {
            console.error("Error in confirmation:", err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            uniqId="ConfirmationModal"
            width="auto"
            padding="0"
            modalClassName={css.pricingModal}
            className={classNames(css.clsAccPageModals, css.clsNewCallSettingSection)}
        >
            <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0 modal-dialog-scrollable")}>
                <div className={classNames(css.clsModalContent, "modal-content")}>
                    <div className={classNames(css.removeBatchDialerModal, "modal-body")}>
                        <div className={css.rbModalTextGroup}>
                            <div className={css.rbModalTitle}>
                                {title}
                            </div>
                            <div className={css.rbModalDetails}>
                                {message}
                            </div>
                        </div>

                        <div className={css.buttonRemoveWrapper} style={{ gap: "10px" }}>
                            <Button 
                                className={css.cancelRemoveBtn} 
                                onClick={onClose}
                                disabled={isSubmitting}
                            >
                                <span className={css.cancelRemoveLabel}>{cancelLabel}</span>
                            </Button>
                            <LoadingButton
                                loading={isSubmitting}
                                disabled={isSubmitting}
                                onClick={handleConfirm}
                                variant={isDanger ? "rose" : "teal"}
                            >
                                <span className={isDanger ? css.connectRmvBtnLabel : css.connectYesBtnLabel}>
                                    {confirmLabel}
                                </span>
                            </LoadingButton>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmationModal;

